import { h } from "preact";

import classname from "../../../../foundation/utils/classname";
import IconProps from "../IconProps";

import styles from "./IconAI.module.css";

const DEFAULT_COLOR = "var(--label-accent)";
const DEFAULT_BACKGROUND_COLOR = "var(--control-accent-light)";

interface Props extends IconProps {
    animate?: boolean;
    backgroundColor?: string;
    size?: number;
}

export default function IconAI({
    class: cssClass,
    color,
    backgroundColor,
    size = 32,
    animate
}: Props) {
    const stroke = color ?? `var(--icon-color, ${DEFAULT_COLOR})`;
    const fill = backgroundColor ?? `var(--icon-background-color, ${DEFAULT_BACKGROUND_COLOR})`;
    const classes = classname(styles.iconAI, cssClass, {
        [styles.animate]: animate
    });

    return (
        <svg class={classes} width={size} height={size} viewBox="0 0 32 32" fill="none">
            <defs>
                <path id="ls" stroke={stroke} d="M11.76 9.66C11.92 9.3 12.4 9.28 12.6 9.58L12.65 9.67 13.18 10.88 13.19 10.9 13.2 10.92 13.24 10.99 13.25 11.01 13.26 11.03C13.36 11.17 13.49 11.28 13.65 11.35H13.65L14.86 11.88 14.95 11.93C15.26 12.13 15.23 12.61 14.87 12.77H14.87L13.65 13.3C13.47 13.38 13.31 13.52 13.22 13.69L13.18 13.77 12.65 14.98 12.65 14.99C12.48 15.38 11.93 15.38 11.77 14.99L11.25 13.79 11.24 13.77 11.23 13.75 11.19 13.68 11.18 13.66 11.17 13.64 11.09 13.54C11.01 13.45 10.9 13.37 10.78 13.32L10.78 13.32 9.55 12.78C9.55 12.78 9.54 12.78 9.54 12.77H9.54C9.16 12.6 9.16 12.05 9.54 11.89V11.89L10.76 11.36 10.78 11.35 10.87 11.3 10.89 11.29 10.91 11.28C11.05 11.19 11.16 11.05 11.23 10.89L11.23 10.89 11.76 9.67 11.76 9.67H11.76Z"/>
                <path id="rs" stroke={stroke} d="M17.3894 14.3643C17.6757 13.7116 18.5611 13.6617 18.9294 14.2256L19.0124 14.3848 19.7536 16.082 19.7634 16.1055 19.7761 16.1279 19.8288 16.2227 19.8396 16.2412 19.8523 16.2598C19.9651 16.4247 20.123 16.5582 20.3112 16.6406H20.3122L22.0163 17.3848 22.1628 17.4629C22.7297 17.8303 22.6812 18.7156 22.029 19.0029L22.0271 19.0039 20.3112 19.7539C20.0941 19.8491 19.9136 20.0133 19.7986 20.2207L19.7536 20.3125 19.0144 22.0049 19.0036 22.0264C18.6954 22.7366 17.6923 22.7293 17.3884 22.0234L16.6638 20.3398 16.655 20.3184 16.6433 20.2988 16.5915 20.2021 16.5798 20.1807 16.5661 20.1602 16.4743 20.0439C16.3748 19.9331 16.2516 19.8415 16.1101 19.7783L16.1091 19.7773 14.3816 19.0137 14.3611 19.0029C13.6581 18.6921 13.6618 17.6954 14.365 17.3896H14.3659L16.0818 16.6406 16.1052 16.6309 16.1267 16.6182 16.2214 16.5654 16.2409 16.5547 16.2585 16.542C16.423 16.4295 16.5566 16.2719 16.6394 16.083L16.6404 16.082 17.3884 14.3643H17.3894Z"/>
                <clipPath id="lsClip">
                    <use href="#ls"/>
                </clipPath>
                <clipPath id="rsClip">
                    <use href="#rs"/>
                </clipPath>
            </defs>
            <g>
                <rect width="32" height="32" rx="6" fill={fill}/>
                <use href="#rs" clip-path="url(#rsClip)" class={styles.rightSparkleFill}/>
                <use href="#rs" class={styles.rightSparkle}/>
                <use href="#ls" clip-path="url(#lsClip)" class={styles.leftSparkleFill}/>
                <use href="#ls" class={styles.leftSparkle}/>
            </g>
        </svg>
    );
}
